import { Box, Heading, Text } from "@chakra-ui/react";

type ErrorProps = {
  readonly statusCode?: number;
  readonly title?: string;
};

type ErrorContext = {
  readonly res?: {
    readonly statusCode?: number;
  } | null;
  readonly err?: {
    readonly statusCode?: number;
  } | null;
};

type ErrorComponentType = ((props: ErrorProps) => JSX.Element) & {
  getInitialProps: (context: ErrorContext) => Promise<{ statusCode: number }>;
};

const ErrorComponent = (({ statusCode = 500, title }: ErrorProps) => {
  return (
    <Box py="16" textAlign="center">
      <Heading size="lg">{statusCode}</Heading>
      <Text mt="3">{title ?? "An unexpected error occurred."}</Text>
    </Box>
  );
}) as ErrorComponentType;

ErrorComponent.getInitialProps = async (
  context: ErrorContext,
): Promise<{ statusCode: number }> => {
  return {
    statusCode: context.res?.statusCode ?? context.err?.statusCode ?? 500,
  };
};

export default ErrorComponent;
